module.exports = __webpack_public_path__ + "img/30-MiControl.cb568f78.jpg";